import { SelectHelperMenuItem } from 'bold-ui'
import locale from 'bold-ui/lib/i18n/locales/pt-BR'
import { CustomSelectFieldProps, SelectField } from 'components/form'
import { FormaFarmaceuticaSelectFieldDocument } from 'graphql/hooks.generated'
import { FormaFarmaceuticaSelectFieldQuery, FormaFarmaceuticaSelectFieldQueryVariables } from 'graphql/types.generated'

import { DEFAULT_SELECT_PAGE_PARAM, useAsyncQuerySelect } from '../useAsyncQuerySelect'

export type FormaFarmaceuticaSelectFieldModel = Partial<
  FormaFarmaceuticaSelectFieldQuery['formasFarmaceuticas']['content'][0]
>

const SkippingEmptyItem = () => <SelectHelperMenuItem>Digite para buscar uma forma farmacêutica.</SelectHelperMenuItem>

const DefaultEmptyItem = () => <SelectHelperMenuItem>{locale.select.emptyItem}</SelectHelperMenuItem>

const extractItems = (data: FormaFarmaceuticaSelectFieldQuery) => data?.formasFarmaceuticas?.content

const variables = (inputQuery: string): FormaFarmaceuticaSelectFieldQueryVariables => ({
  input: {
    query: inputQuery,
    pageParams: {
      ...DEFAULT_SELECT_PAGE_PARAM,
      sort: ['nomeFormaFarmaceutica'],
    },
  },
})

const skip = (inputString: string) => inputString?.trim()?.length < 2

export function FormaFarmaceuticaSelectField(props: CustomSelectFieldProps<FormaFarmaceuticaSelectFieldModel>) {
  const { skipping, selectProps } = useAsyncQuerySelect<
    FormaFarmaceuticaSelectFieldModel,
    FormaFarmaceuticaSelectFieldQuery,
    FormaFarmaceuticaSelectFieldQueryVariables
  >({
    query: FormaFarmaceuticaSelectFieldDocument,
    extractItems,
    variables,
    skip,
    debounceTime: 500,
  })

  const itemToString = (item: FormaFarmaceuticaSelectFieldModel) => item?.nome

  return (
    <SelectField<FormaFarmaceuticaSelectFieldModel>
      itemToString={itemToString}
      components={{
        EmptyItem: skipping ? SkippingEmptyItem : DefaultEmptyItem,
      }}
      {...selectProps}
      {...props}
    />
  )
}
